import classNames from 'classnames';
import React from 'react';

import './AccountMenuItemGroup.scss';

export interface Props {
  showSeparator?: boolean;
  scroll?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const AccountMenuItemGroup: React.FC<Props> = ({
  showSeparator = false,
  scroll = false,
  children,
  className,
}) => {
  const containerClassName = classNames('AccountMenuItemGroup', className, {
    AccountMenuItemGroup__scroll: scroll,
  });

  return (
    <div className={containerClassName}>
      {children}
      {showSeparator && (
        <hr
          className="AccountMenuItemGroup__separator"
          data-testid="separator"
        />
      )}
    </div>
  );
};
